import React from 'react';
import { MdArrowBack } from 'react-icons/md';

// Pill "Back" button used at the top of every view page (styles: .hc-back-btn in App.css).
export default function BackButton({ onClick, label = 'Back', className = '' }) {
  return (
    <button type="button" className={`hc-back-btn ${className}`} onClick={onClick}>
      <span className="hc-back-btn-icon">
        <MdArrowBack size={15} />
      </span>
      <span>{label}</span>
    </button>
  );
}
